module.exports = "https://qp-assets.quero.com/assets/images/credit-card-brands/mastercard-nobg.svg?06b5d6443642000077abd77696a52648";